import { createSvgComponent } from "../../icon/createSvgComponent";
import ReceiptText from "@core/icon/assets/receipt-text.svg";
export default createSvgComponent(ReceiptText);